import { getColor } from 'common/constants/_colors';
import {
  PieChart as RechartsPie,
  Pie,
  Sector,
  ResponsiveContainer,
  Cell
} from 'recharts';

/*
was taken from recharts docs: https://recharts.org/en-US/examples/CustomActiveShapePieChart
with some custom adjustments for our case
*/

const renderActiveShape = props => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text
        x={cx}
        y={cy}
        dy={0}
        textAnchor='middle'
        style={{ fontSize: '2.5rem', fill: getColor('shuttleGray') }}
      >
        {payload.round_fte_p}%
      </text>
      <text
        x={cx - 2}
        y={cy}
        dy={20}
        textAnchor='middle'
        style={{ fontSize: '1.3rem', fill: getColor('shuttleGray') }}
      >
        {payload.fte} FTE
      </text>

      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill='none'
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke='none' />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill='#333'
      >
        {payload.name}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill='#999'
      >
        {`( ${payload.round_fte_p}%
        ${payload.benchmark ? `/ ${payload.benchmark}%` : ``}
         )`}
      </text>
    </g>
  );
};

const PieChart = ({ data, activeIdx }) => {
  return (
    <ResponsiveContainer width='100%' height='100%'>
      <RechartsPie width='auto' height='auto'>
        <Pie
          activeIndex={activeIdx}
          activeShape={renderActiveShape}
          data={data}
          cx='50%'
          cy='50%'
          innerRadius={80}
          outerRadius={100}
          dataKey='value'
        >
          {data.map((item, idx) => (
            <Cell
              key={idx}
              fill={item.color}
              style={{ opacity: idx === activeIdx ? 1 : 0.2 }}
            />
          ))}
        </Pie>
      </RechartsPie>
    </ResponsiveContainer>
  );
};

export default PieChart;
